<template>
 <div>
   <div>
    <b-card class="mx-auto" style="min-height:300px;max-width:1160px;" no-body>
      <b-tabs v-model="tabIndex" active-nav-item-class="font-weight-bold" >
        <b-tab no-body >
          <template v-slot:title>
            PO List
          </template>
          
          <PoList> </PoList>

        </b-tab>

        <b-tab no-body>
          <template v-slot:title>
            PO Item Search
          </template>

          <PoItemSearch ref="itemSearch"> </PoItemSearch>

        </b-tab>
        
      </b-tabs>
    </b-card>
  </div> 


  <div v-if="isBusy">
    <p class="mt-4"><b-spinner></b-spinner></p>
  </div>

  <div v-if="errored">
    <p class="text-danger mt-4">An error occurred loading data.</p>
    <p>{{ error }}</p>
  </div>

 </div>
</template>

<script>
import PoList from '@/components/poviewer/PoList.vue';
import PoItemSearch from '@/components/poviewer/PoItemSearch.vue';
export default {
  name: "PurchaseOrders",
  props: {},
  components: {
    PoList,
    PoItemSearch
  },

  data: function() {
    return {
      state: this.$store.state,
      projectId: this.$route.params.id, 
      project: null,
      isBusy: true,
      modules: [],
      tabIndex: 0,
      errored: false, 
      error: "",
    };
  },

 computed: {

    },

  methods: {

   fetchProject() {
      this.$auth.acquireToken().then(token => {
          this.$http.get(
            "api/Project/"  + this.projectId,
            {
              headers: { Authorization: "Bearer " + token }
            }
          ) 
          .then(response => {

            if (response.status == 204){
              this.errored = true;
              this.error = "Project " + this.projectId + ": Not found/No user access ";
            }
            else {

             this.project = response.data.project;
             this.modules = response.data.modules;
             this.$store.setItem("project",this.project.projectId + " " + this.project.description);
             this.$store.setItem("projectId", this.project.projectId);
             this.setProject();

              //check for module assignment
              if (!this.modules.includes('poviewer')){
                  this.errored = true;
                  this.loaded = false;
                  this.error = this.project.projectId + " PO Viewer access not assigned to user.";
              }

            };

          })
          .catch(error => {
            console.log (error);
            this.errored = true;
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => (this.isBusy = false));
      });
    },

    setProject() {
      if (this.project){
      this.$store.setItem("projectId", this.project.projectId);
      this.$store.setItem("project",  this.project.projectId + " " + this.project.description );
      this.$store.setItem("modules", this.modules);
      }

    },           

    setBreadcrumb() {
      this.$store.setItem("breadcrumbs",[ 
      {
        text: this.projectId,
        to: { name: 'Project', params: { Id: this.projectId } }
      },
      {
        text: 'Purchase Orders'
      }
      ]);
    }
  },

activated: function() {
    this.setBreadcrumb();
    this.setProject();
    },

  mounted: function() {
     
      this.errored = false;
      this.isBusy = true;
      this.fetchProject();
  }
};
</script>

<style>

</style>